import { render, staticRenderFns } from "./MenuFood.vue?vue&type=template&id=52dfca7e"
import script from "./MenuFood.vue?vue&type=script&lang=js"
export * from "./MenuFood.vue?vue&type=script&lang=js"
import style0 from "./MenuFood.vue?vue&type=style&index=0&id=52dfca7e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52dfca7e')) {
      api.createRecord('52dfca7e', component.options)
    } else {
      api.reload('52dfca7e', component.options)
    }
    module.hot.accept("./MenuFood.vue?vue&type=template&id=52dfca7e", function () {
      api.rerender('52dfca7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/MenuFood.vue"
export default component.exports